import styled from 'styled-components';

export const ModalBody = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #667085;
  word-break: break-word;
`;
